const config = {
  API_BASE_URL:
    process.env.REACT_APP_API_BASE_URL // Usa la variable si existe
      ? process.env.REACT_APP_API_BASE_URL
      : "http://localhost:8000",         // Si no existe, usa localhost
};

export default config;